import React from 'react';
import { Navigate, Outlet, RouteObject, useLocation } from 'react-router-dom';
import DashboardPage from './pages/dashboard-page/DashboardPage';
import GeoDetailPage from './pages/geo-detail-page/GeoDetailPage';
import GeoDevicesPage from './pages/geo-devices-page/GeoDevicesPage';
import SignInPage from './pages/sign-in-page/SignInPage';
import WeatherDetailPage from './pages/weather-detail-page/WeatherDetailPage';
import WeatherDevicesPage from './pages/weather-devices-page/WeatherDevicesPage';
import { dashboardPath, defaultPath, geoPath, signInPath, weatherListUrl, weatherPath } from './routes.constants';
import useAuthStore from './stores/auth.store';

export * from './routes.constants';

function ProtectedRoute() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const location = useLocation();
  if (!isAuthenticated) return <Navigate to={signInPath} state={{ from: location }} replace />;
  return <Outlet />;
}

function PublicOnlyRoute() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  if (isAuthenticated) return <Navigate to={weatherListUrl} replace />;
  return <Outlet />;
}

const routes: RouteObject[] = [
  {
    path: defaultPath,
    children: [
      { index: true, element: <Navigate to={weatherListUrl} replace /> },
      { path: signInPath, element: <PublicOnlyRoute />, children: [{ index: true, element: <SignInPage /> }] },
      {
        path: dashboardPath,
        element: <ProtectedRoute />,
        children: [
          {
            element: <DashboardPage />,
            children: [
              { index: true, element: <Navigate to={weatherPath} replace /> },
              { path: weatherPath, element: <WeatherDevicesPage /> },
              { path: `${weatherPath}/:deviceUuid`, element: <WeatherDetailPage /> },
              { path: geoPath, element: <GeoDevicesPage /> },
              { path: `${geoPath}/:deviceUuid`, element: <GeoDetailPage /> },
            ],
          },
        ],
      },
      { path: '*', element: <Navigate to={defaultPath} replace /> },
    ],
  },
];

export default routes;
